export class Clonable {
  public clone() {
    return JSON.parse(JSON.stringify(this));
  }
}
